import { ColumnFilterElementTemplateOptions } from 'primereact/column'
import { Dropdown } from 'primereact/dropdown'

import i18n from '../../utils/i18n'

export const BooleanFilterTemplate = (
  options: ColumnFilterElementTemplateOptions,
) => {
  if (!options) return null

  const allowanceChargesOptions: string[] = ['true', 'false']

  const valueTemplate = (option: boolean, props: any) => {
    if (option) {
      return (
        <>
          {option.toString() === 'true' ? (
            <>
              <i
                className="pi pi-check"
                style={{ color: 'var(--green-500)' }}
              />{' '}
              {i18n.t('common.labels.yes')}
            </>
          ) : (
            <>
              <i className="pi pi-times" style={{ color: 'var(--red-500)' }} />{' '}
              {i18n.t('common.labels.no')}
            </>
          )}
        </>
      )
    }

    return <>{props.placeholder}</>
  }

  const itemTemplate = (option: boolean) => {
    return (
      <>
        {option.toString() === 'true' ? (
          <>
            <i className="pi pi-check" style={{ color: 'var(--green-500)' }} />{' '}
            {i18n.t('common.labels.yes')}
          </>
        ) : (
          <>
            <i className="pi pi-times" style={{ color: 'var(--red-500)' }} />{' '}
            {i18n.t('common.labels.no')}
          </>
        )}
      </>
    )
  }

  return (
    <Dropdown
      value={options.value}
      options={allowanceChargesOptions}
      onChange={e => options.filterCallback(e.value)}
      valueTemplate={valueTemplate}
      itemTemplate={itemTemplate}
      className="p-column-filter"
      placeholder={i18n.t('common.placeholders.search')}
    />
  )
}
